import { Reveal } from "@/components/site/Reveal";
import { fileUrl } from "@/lib/api";
import { IMAGES } from "@/lib/data";

export default function Gallery({ photos }) {
  const fallback = [
    { url: IMAGES.clinic1, caption: "Consultation room" },
    { url: IMAGES.waiting, caption: "Waiting lounge" },
    { url: IMAGES.clinic2, caption: "Warm interiors" },
    { url: IMAGES.lotusWhite, caption: "A calm space" },
  ];
  const items = (photos && photos.length ? photos : fallback).slice(0, 8);

  return (
    <section id="gallery" className="relative py-28 lg:py-36 max-w-7xl mx-auto px-6 lg:px-10" data-testid="gallery">
      <Reveal className="max-w-2xl">
        <p className="font-sans text-xs tracking-[0.3em] uppercase text-blush-dusty mb-4">The space</p>
        <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl text-olive-deep leading-[1.05]">
          A clinic that feels <span className="italic text-blush-dusty">like a deep breath.</span>
        </h2>
      </Reveal>

      <div className="mt-16 grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
        {items.map((p, i) => (
          <Reveal key={p.id || i} delay={(i % 4) * 0.08}
            className={i % 5 === 0 ? "col-span-2 row-span-2" : ""}>
            <figure className="group relative overflow-hidden rounded-3xl h-full" data-testid={`gallery-item-${i}`}>
              <img src={fileUrl(p.url)} alt={p.caption || "Clinic"}
                className={`w-full object-cover group-hover:scale-105 transition-transform duration-700 ${i % 5 === 0 ? "h-full min-h-[20rem]" : "aspect-square"}`} />
              {p.caption && (
                <figcaption className="absolute inset-x-0 bottom-0 p-5 bg-gradient-to-t from-olive-deep/70 to-transparent">
                  <span className="font-sans text-xs tracking-widest uppercase text-cream">{p.caption}</span>
                </figcaption>
              )}
            </figure>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
